import { setIn } from "formik";

const actions = {
  SET_ALL_INVOICES: "SET_ALL_INVOICES",
  GET_INVOICE: "GET_INVOICE",
  UPDATE_INVOICE: "UPDATE_INVOICE",
  UPDATE_INVOICE_SAGA: "UPDATE_INVOICE_SAGA",
  SELECT_CURRENT_INVOICE: "SELECT_CURRENT_INVOICE",
  TOGGLE_VIEW: "INVOICE_TOGGLE_VIEW",
  SET_INVOICE_FORM: "SET_INVOICE_FORM",
  SET_INCOMING_INVOICE_FORM: "SET_INCOMING_INVOICE_FORM",
  SET_OUTGOING_INVOICE_FORM: "SET_OUTGOING_INVOICE_FORM",
  SET_INVOICE_TAB_INDEX: "SET_INVOICE_TAB_INDEX",
  UPDATE_EDIT_INVOICE: "INVOICE_UPDATE_EDIT_INVOICE",
  initData: () => ({ type: actions.GET_INVOICE }),
  setInvoices: (invoices) => ({
    type: actions.SET_ALL_INVOICES,
    payload: invoices,
  }),
  setInvoiceForm: (data) => ({
    type: actions.SET_INVOICE_FORM,
    payload: data,
  }),
  setIncomingInvoiceForm: (data) => ({
    type: actions.SET_INCOMING_INVOICE_FORM,
    payload: data,
  }),
  setOugoingInvoiceForm: (data) => ({
    type: actions.SET_OUTGOING_INVOICE_FORM,
    payload: data,
  }),
  setInvoiceTabIndex: (data) => ({
    type: actions.SET_INVOICE_TAB_INDEX,
    payload: data,
  }),
  deleteInvoice: (selected) => {
    return (dispatch, getState) => {
      const invoices = getState().Invoices.invoices;
      const newInvoices = [];
      invoices.forEach((invoice) => {
        const selectedIndex = selected.indexOf(invoice.key);
        if (selectedIndex === -1) {
          newInvoices.push(invoice);
        }
      });
      dispatch({
        type: actions.UPDATE_INVOICE_SAGA,
        invoices: newInvoices,
      });
    };
  },
  updateInvoice: (invoice) => {
    return (dispatch, getState) => {
      const invoices = getState().Invoices.invoices;
      const index = invoices.map((inv) => inv.id).indexOf(invoice.id);
      if (index === -1) {
        invoices.push(invoice);
      } else {
        invoices[index] = invoice;
      }
      dispatch({
        type: actions.UPDATE_INVOICE_SAGA,
        invoices,
        invoice,
      });
    };
  },
  selectCurrentInvoice: (id) => ({ type: actions.SELECT_CURRENT_INVOICE, id }),
  toggleView: (view) => ({ type: actions.TOGGLE_VIEW, view }),
  editInvoice: (invoice) => ({ type: actions.UPDATE_EDIT_INVOICE, invoice }),
};
export default actions;
